import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const Board = styled(motion.div)`
  margin: 0 auto;
  padding: 40px 0px 40px;
  width: 1200px;
`;
